import weightMngInitialQuestions from './Initial/questions';
import weightMngFollowupQuestions from './followup/questions';

const weightManagementQuestions = [...weightMngInitialQuestions, ...weightMngFollowupQuestions];
export default weightManagementQuestions;
export type { WeightManagementAnswerField } from './Initial/questions';
export type { WeightManagementFollowupFieldAnswers } from './followup/questions';
